const initialStateVN = {
  // PERSONAL INFORMATION
  fullName: '',
  firstName: '',
  middleName: '',
  lastName: '',
  dateOfBirth: '',
  gender: '',

  // OCR FILE NAMES
  fileNames: {
    file1: '',
    file2: '',
  },

  // IDENTITY NUMBER
  idCardNo: '',

  // CURRENT RESIDENTIAL ADDRESS
  streetNo: '',
  streetName: '',
  ward: '',
  district: '',
  city: '',

  // TERMS AND CONDITIONS
  nationalIDConsentObtained: false,
  socialSecurityConsentObtained: false,

  // REPORTING REFERENCE NUMBER
  reportingReference: '',

  // ERROR HANDLING
  errors: {},
};

export default initialStateVN;
